import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const authzSubjectPermissionGroupMenuRegistry = {
    core_authzSubjectPermissionGroup: {
        label: "Authz Subject Permission Group",
        link: PAGE_URL.AUTHZ_SUBJECT_PERMISSION_GROUP_PAGE,
        key: PAGE_URL.AUTHZ_SUBJECT_PERMISSION_GROUP_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default authzSubjectPermissionGroupMenuRegistry;
